import { Component, Input, OnInit } from '@angular/core';
import { ClientDetails } from 'src/app/interfaces/home.interface';
import { slaComplianceData } from './sla-compliance.interface';

@Component({
  selector: 'app-sla-complience',
  templateUrl: './sla-compliance.component.html',
  styleUrls: ['./sla-compliance.component.scss'],
})
export class SlaComplianceComponent implements OnInit {
  chartWidth = 150;
  chartHeight = 150;

  @Input() slaInformation: any;
  @Input() clientDetails!:ClientDetails;
  @Input() width: number = 45;
  @Input() height: number = 45;
  constructor() {}

  slaComplianceChartData:slaComplianceData[] = [
    {
      id: 1,
      color: '#7f7f91',
      value: 0,
    },
    {
      id: 2,
      color: '#71b06b',
      value: 0,
    },
  ];

  ngOnInit(): void {
    if(this.clientDetails){
      this.slaComplianceChartData[0].value = (100 - this.clientDetails.slaComplianceCurrent)
      this.slaComplianceChartData[1].value = this.clientDetails.slaComplianceCurrent
    }

  }
}
